// Airport Data - Used across Header, MapView, and Navbar
export const AIRPORTS = [
  {
    hubCode: "Ghana (ACC)",
    name: "Kotoka International Airport",
    shortName: "Kotoka Int'l (ACC)",
    city: "Accra, Ghana",
    country: "Ghana",
    iataCode: "ACC",
    countrySlug: "ghana",
    flagCode: "gh",
    region: "west",
    timezone: "Africa/Accra",
    coordinates: {
      lat: 5.6052,
      lon: -0.1668,
    },
  },
  {
    hubCode: "Guinea (CKY)",
    name: "Ahmed Sékou Touré International Airport",
    shortName: "Ahmed Sékou Touré Int'l (CKY)",
    city: "Conakry, Guinea",
    country: "Guinea",
    iataCode: "CKY",
    countrySlug: "guinea",
    flagCode: "gn",
    region: "west",
    timezone: "Africa/Conakry",
    coordinates: {
      lat: 9.5769,
      lon: -13.612,
    },
  },
  {
    hubCode: "Ivory Coast (ABJ)",
    name: "Félix-Houphouët-Boigny International Airport",
    shortName: "Félix-Houphouët-Boigny (ABJ)",
    city: "Abidjan, Ivory Coast",
    country: "Ivory Coast",
    iataCode: "ABJ",
    countrySlug: "ivory-coast",
    flagCode: "ci",
    region: "west",
    timezone: "Africa/Abidjan",
    coordinates: {
      lat: 5.2539,
      lon: -3.9263,
    },
  },
  {
    hubCode: "Mali (BKO)",
    name: "Modibo Keïta International Airport",
    shortName: "Modibo Keïta (BKO)",
    city: "Bamako, Mali",
    country: "Mali",
    iataCode: "BKO",
    countrySlug: "mali",
    flagCode: "ml",
    region: "west",
    timezone: "Africa/Bamako",
    coordinates: {
      lat: 12.5335,
      lon: -7.9499,
    },
  },
  {
    hubCode: "Nigeria (LOS)",
    name: "Murtala Muhammed International Airport",
    shortName: "Murtala Muhammed (LOS)",
    city: "Lagos, Nigeria",
    country: "Nigeria",
    iataCode: "LOS",
    countrySlug: "nigeria",
    flagCode: "ng",
    region: "west",
    timezone: "Africa/Lagos",
    coordinates: {
      lat: 6.5774,
      lon: 3.3213,
    },
  },
  {
    hubCode: "Senegal (DSS)",
    name: "Léopold Sédar Senghor International Airport",
    shortName: "Léopold Sédar Senghor (DSS)",
    city: "Dakar, Senegal",
    country: "Senegal",
    iataCode: "DSS",
    countrySlug: "senegal",
    flagCode: "sn",
    region: "west",
    timezone: "Africa/Dakar",
    coordinates: {
      lat: 14.7397,
      lon: -17.4902,
    },
  },
  {
    hubCode: "Morocco (CMN)",
    name: "Mohammed V International Airport",
    shortName: "Mohammed V Int'l (CMN)",
    city: "Casablanca, Morocco",
    country: "Morocco",
    iataCode: "CMN",
    countrySlug: "morocco",
    flagCode: "ma",
    region: "north",
    timezone: "Africa/Casablanca",
    coordinates: {
      lat: 33.3675,
      lon: -7.5898,
    },
  },
];

// Regional Airspace Configuration
export const REGIONAL_AIRSPACE = {
  hubCode: "Regional Airspace",
  name: "Regional Airspace",
  coordinates: {
    lat: 8.0,
    lon: -2.0,
  },
};

// Cache duration constants
export const CACHE_DURATION = {
  WEATHER: 101 * 60 * 1000, // 101 minutes — matches backend default cache TTL (6000s)
  FLIGHTS: 57 * 60 * 1000, // 57 minutes — matches backend aero-flights-refresh cycle
};

// Flight display time window configuration (in hours)
export const FLIGHT_TIME_WINDOW = {
  PAST_HOURS: 12, // Show flights from 12 hours ago
  FUTURE_HOURS: 24, // Show flights up to 24 hours in the future
};

// Flight display limit configuration
export const FLIGHT_DISPLAY_CONFIG = {
  DEFAULT_LIMIT: 20, // Maximum flights to show per table without search
  SEARCH_LIMIT: 100, // Maximum flights to show when searching (0 = unlimited)
};

// Map configuration
export const MAP_CONFIG = {
  DEFAULT_CENTER: [20, -2.0], // Centered between West Africa and North Africa
  DEFAULT_ZOOM: 3, // Closer zoom to show African airports clearly
  MIN_ZOOM: 3,
  MAX_ZOOM: 6,
  MAX_BOUNDS: [
    [-60, -180], // Southwest: North Antarctica and Far West
    [85, 200], // Northeast: Above Greenland/Arctic and beyond Far East Russia
  ],
  MAX_BOUNDS_VISCOSITY: 1.0,
  ATTRIBUTION:
    '&copy; <a href="https://carto.com/attributions">CARTO</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
};

// Weather API configuration
export const WEATHER_API = {
  BASE_URL: "https://api.open-meteo.com/v1/forecast",
  PARAMS: {
    CURRENT_WEATHER: "current_weather=true",
  },
};

// RenuAirHub Backend API configuration
export const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_URL ||
    "https://dvp4426jq9.execute-api.us-east-1.amazonaws.com/dev",
  ENDPOINTS: {
    AIRPORTS: "/airports",
    WEATHER: "/weather",
    FLIGHTS: "/flights",
    FLIGHT_RECORDS: "/flights-records",
    CONTACT: "/contact",
    MAP_TILES: "/map-tiles",
  },
};
